import React, { useState, useContext } from "react";
import "./Textfield.css";
import opendark from "../../Assets/Images/Password Open Dark.svg";
import closedark from "../../Assets/Images/Password Close Dark.svg";
import openlight from "../../Assets/Images/Password Open Light.svg";
import closelight from "../../Assets/Images/Password Close Light.svg";
import { DynamicContext } from "../../Context/DynamicContext";
import styled from "@emotion/styled";

export const StyledErrorMessage = styled("div")({
  color: "red",
  fontSize: "14px",
  marginTop: "6px",
  width: "fit-content",
});
export const StyledImage = styled("img")`
  height: 20px;
  width: 20px;
  position: absolute;
  left: 23px;
  top: 8px;
`;
const DynamicTextField = ({
  label,
  name,
  value,
  icon = null,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  required = false,
  showPasswordToggle = false,
  error = "",
  errorMessage = "",
  readOnly = false,
  style = {},
  containerStyle = {},
  labelStyle = {},
  className = "textfield-input",
  onKeyDown = () => {},
  disabled = false,
  onWheel,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { isDarkMode } = useContext(DynamicContext);

  const handleTogglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const getPasswordIcon = () => {
    if (isPasswordVisible) {
      return isDarkMode ? opendark : openlight;
    } else {
      return isDarkMode ? closedark : closelight;
    }
  };

  const handleChange = (e) => {
    if (e.target.value.startsWith(" ")) {
      e.target.value = e.target.value.trimStart();
    }
    onChange(e);
  };

  const handleBlur = (e) => {
    e.target.value = e.target.value.trim();
    onChange(e); 
    if (onBlur) onBlur(e);
  };

  return (
    <div className="textfield-container" style={containerStyle}>
      <label htmlFor={name} className="textfield-label" style={labelStyle}>
        {label} {required && <span className="required-asterisk">*</span>}
      </label>

      <div style={{ position: "relative" }} className="textfield-input-container">        
        <input
          id={name}
          name={name}
          type={showPasswordToggle && isPasswordVisible ? "text" : type}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          required={required}
          className={`${className} ${showPasswordToggle ? "password-field" : ""}`}
          readOnly={readOnly}
          disabled={disabled}
          style={style}
          onKeyDown={onKeyDown}
          onWheel={onWheel}
        />
        {icon && <StyledImage src={icon} alt="icon" />}
        {showPasswordToggle && type === "password" && (
          <img
            src={getPasswordIcon()}
            alt="Toggle Password Visibility"
            className="password-toggle-icon"
            onClick={handleTogglePasswordVisibility}
          />
        )}
      </div>

      {error && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
    </div>
  );
};

export default DynamicTextField;